<template>
  <transition name="fade" @after-leave="handleAfterLeave">
    <div @mouseenter="clearTimer" @mouseleave="startTimer" class="soft-switch show-hide" v-if="visible">
      <div class="content">
        <span class="text-over-two" :title="content">{{ content }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SoftSwitch",
  data () {
    return {
      timer: null,
      content: "",
      duration: 2000,
      visible: false,
    };
  },
  mounted () {
    this.startTimer()
  },
  methods: {
    clearTimer () {
      clearTimeout(this.timer)
    },
    startTimer () {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.visible = false
          }
        }, this.duration)
      }
    },
    handleAfterLeave () {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
  }
};
</script>

<style lang="scss" scoped>
.text-over-two {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.show-hide {
  animation: showhide 1s ease;
  -moz-animation: showhide 1s; /* Firefox */
  -webkit-animation: showhide 1s; /* Safari 和 Chrome */
  -o-animation: showhide 1s;
}
@-webkit-keyframes showhide {
  0% {
    opacity: 0;
    top: -100%;
  }
  20% {
    opacity: 20%;
    top: 0;
  }
  100% {
    opacity: 1;
    top: 320px;
  }
}
.soft-switch {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  width: 433px;
  height: 122px;
  padding: 20px 60px;
  overflow: visible;
  transition: opacity 0.3s, transform 0.4s, top 0.4s;
  box-sizing: border-box;
  position: fixed;
  left: 50%;
  // top: 320px;
  top: 50%;
  transform: translate(-50%, -50%);

  z-index: 9999;
  cursor: pointer;
  background: url("./images/swith_bg.png") no-repeat;
  // background: url("//cdn.classba.cn/public/nomalization/img/swith_bg.png") no-repeat;
  background-size: 100% 100%;
  .content {
    color: rgba(255, 255, 255, 1);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SoftSwitch/index.vue